export default __webpack_public_path__ + "static/media/c392df04a22abdf0b54916c6b5834f37.svg";